module.exports = __webpack_public_path__ + "img/dd6f657.png";